import type SessionService from '@efdigital/ll-addon-auth/services/session';
import type CoacheeService from '@efdigital/ll-xceed-v2/services/coachee';
import {
  getQuizAnswerPair,
  type QuizAnswerPair,
} from '@efdigital/ll-xceed-v2/utils/quiz/quiz-answer-pair';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

import type { CoachingCoacheeCohortModel } from '../cohort';

export type CoachingCoacheeCohortCoachesModel = CoachingCoacheeCohortModel & {
  chemistryQuiz?: QuizAnswerPair;
};

export default class CoachingCoacheeCohortCoachesRoute extends Route<CoachingCoacheeCohortModel> {
  @service declare coachee: CoacheeService;
  @service declare store: Store;
  @service declare session: SessionService;

  async model(): Promise<CoachingCoacheeCohortCoachesModel> {
    const parentModel = (await this.modelFor(
      'coaching.coachee.cohort'
    )) as CoachingCoacheeCohortModel;

    const quizId = parentModel.coaching.quiz?.id;
    if (!quizId) {
      return parentModel;
    }

    const chemistryQuiz = await getQuizAnswerPair(
      quizId,
      this.session.cached.userId!,
      this.store
    );

    return {
      ...parentModel,
      chemistryQuiz,
    };
  }
}
